import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function NotFoundPage() {
    const { t } = useTranslation();

    return (
        <>
            <Typography variant="h4">{t('Page not found')}</Typography>
            <Typography>{t('The page you are looking for does not exist.')}</Typography>
        </>
    );
}
